import { SlingoRequestSpinState } from "slingo/states/slingo-request-spin-state";

export class EJRequestSpinState extends SlingoRequestSpinState {
    //
}
